import styled from 'styled-components';

export const VelocityTabs = styled.div`
  justify-content: center;
  padding: 15px 0 30px 0;
  display: flex;
`;

export const VelocityWhiteHeader = styled.div`
  justify-content: flex-end;
  align-items: center;
  display: flex;

  & > div {
    margin-left: 20px;
  }
`;

export const VelocityWhiteTable = styled.div`
  padding: 30px 0 5px 0;
`;
